import { Cell } from 'common/src/designSystem/components/table/cell';
import { VolunteerRegistrationFragment } from 'common/src/generated/types';
import { HeaventPaths } from 'common/src/util/paths/heaventPaths';
import * as React from 'react';
import { BadgesPlus } from '../../../components/badgesPlus/badgesPlus';
import { useHeavent } from '../../../hooks/useHeavent';

interface IVolunteerRegistrationTeamCodeCellProps {
    volunteerRegistration: VolunteerRegistrationFragment;
}

export const VolunteerRegistrationTeamCodeCell = (
    props: IVolunteerRegistrationTeamCodeCellProps
) => {
    const {
        history,
        params: { organizationId, eventId, segmentId }
    } = useHeavent();
    const badges = React.useMemo(
        () =>
            (props.volunteerRegistration.teams || []).map(({ teamCode }) => ({
                id: teamCode,
                color: 'gray',
                icon: null,
                text: teamCode,
                onClick() {
                    history.push(
                        HeaventPaths.VOLUNTEERS_LIST_USER_PANEL_TEAM(
                            organizationId,
                            eventId,
                            segmentId,
                            props.volunteerRegistration.userInfo.id,
                            teamCode
                        )
                    );
                }
            })),
        [props.volunteerRegistration]
    );

    return (
        <Cell>
            <BadgesPlus badges={badges} />
        </Cell>
    );
};
